import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import * as html2canvas from "html2canvas";
import {
  NbWindowService,
  NbWindowState,
  NbDialogService,
} from "@nebular/theme";
import { CampaignProjectService } from "../../../../@core/api/campaign-project.service";
import { Campaign } from "../../../../@core/data/campaign";
import { Router } from "@angular/router";
import { ConfirmDialogComponent } from "../../../utils/confirm-dialog/confirm-dialog.component";

@Component({
  selector: "ngx-projects-campaign-row",
  templateUrl: "./projects-campaign-row.component.html",
  styleUrls: ["./projects-campaign-row.component.scss"],
})
export class ProjectsCampaignRowComponent implements OnInit {
  @Input() campaign: Campaign;
  @Output() updateList = new EventEmitter();

  constructor(
    private router: Router,
    private dialogService: NbDialogService,
    private campaignService: CampaignProjectService
  ) {}

  async ngOnInit() {}

  show(type) {
    switch (type) {
      case "edit":
        this.router.navigate(["home", "projects-campaign", this.campaign.id]);
        break;
      case "copy":
        this.copyCampaign();
        break;

        case "statistics":
          this.router.navigate(["home", "projects-statistics", this.campaign.id]);
          break;


      case "export":
        this.router.navigate(["home", "projects-export", this.campaign.id]);
        break;

      case "delete":
        this.dialogService
          .open(ConfirmDialogComponent, {
            context: { operation: "eliminare " + this.campaign.name },
          })
          .onClose.subscribe((res) => {
            if (res) {
              this.DeleteCampaign();
            }
          });
        break;
    }
  }

  async copyCampaign() {
    let campaign = this.campaign;
    campaign.name = campaign.name + " (Copia)";
    let res = <any>await this.campaignService.createCampaign(campaign);
    this.updateList.emit();
  }

  async toggleCampaign() {
    let campaign = this.campaign;
    campaign.pause = !campaign.pause;
    let res = <any>(
      await this.campaignService.editCampaign(campaign, campaign.id)
    );
    this.updateList.emit();
  }

  async DeleteCampaign() {
    await this.campaignService.deleteCampaign(this.campaign.id);
    this.updateList.emit();
  }
}
